import { STRINGS } from '../../constants';
import apiCaller from '../http';
import URLS from '../urls';

const fetchCars = async (profileId, setError, saveCars, logoutHandler) => {
  await apiCaller
    .get(`${URLS.CARS_LIST}${profileId}/`)
    .then((response) => {
      if (response.data !== undefined) {
        setError(null);
        saveCars(response.data);
      } else {
        setError(STRINGS.common.error404Text);
      }
    })
    .catch((e) => {
      if (e.message === STRINGS.common.errorMissingCredentials) {
        logoutHandler();
      }
      if (e.message === STRINGS.common.error400Template) {
        setError(STRINGS.common.error400Text);
      }
      setError(STRINGS.common.error404Text);
    });
};

export default fetchCars;
